import React from 'react';
import EmailActions from './EmailActions';

const getInvoiceEmailType = (invoice) => {
  const source = invoice || {};
  const type = String(source.documentTitle || source.type || 'Invoice').trim();
  if (Number(source.transactionTypeId) === 5) {
    const isReturn = String(source.to?.name || '').toUpperCase().replace(/[^A-Z0-9]/g, '') === 'IRENESWIGSNEWYORK'
      || /^return$/i.test(type);
    return { key: isReturn ? 'transferReturn' : 'transfer', label: type };
  }
  const normalized = type.toLowerCase();
  if (normalized.includes('credit memo') || normalized.includes('return')) return { key: 'return', label: 'Return' };
  if (normalized.includes('repair')) return { key: 'repair', label: 'Repair Invoice' };
  if (normalized.includes('payment')) return { key: 'payment', label: 'Payment' };
  if (normalized.includes('transfer') || normalized.includes('receiv')) return { key: 'transfer', label: type };
  return { key: 'invoice', label: type || 'Invoice' };
};

function InvoiceEmailActions({
  invoice,
  disabled = false,
  loading = false,
  buttonClassName = 'button small blue',
  successMessage,
  onSent,
  onError,
  onLoadingChange,
}) {
  const emailType = getInvoiceEmailType(invoice);
  const isRepair = emailType.key === 'repair';
  const recipient = isRepair ? invoice?.from : invoice?.to;
  const number = invoice?.invoiceNo || '';

  return (
    <EmailActions
      endpoint={invoice ? `/invoices/${number}/email` : ''}
      requestConfig={{
        params: invoice?.transactionTypeId
          ? { transactionTypeId: invoice.transactionTypeId }
          : undefined,
      }}
      templateKey={emailType.key}
      templateValues={{
        document: emailType.label,
        documentNumber: number ? ` #${number}` : '',
        invoiceNo: number,
        recipientName: recipient?.name || '',
        customerName: recipient?.name || '',
      }}
      recipient={recipient?.email || ''}
      from={invoice?.businessAddress?.email || (!isRepair ? invoice?.from?.email : '') || ''}
      subject={`${emailType.label} #${number}`.trim()}
      quickTitle={`Send ${emailType.label}`}
      quickPrompt={`Send ${emailType.label.toLowerCase()} to:`}
      attachmentPdf={`Invoice_${number}.pdf`}
      attachmentExcel={`Invoice_${number}.xlsx`}
      disabled={disabled || !invoice}
      loading={loading}
      buttonClassName={buttonClassName}
      successMessage={successMessage}
      onLoadingChange={onLoadingChange}
      onSent={onSent}
      onError={onError}
    />
  );
}

export default InvoiceEmailActions;
